"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import Sidebar from "@/components/Sidebar";

export default function AppShell({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const isLoginPage = pathname === "/login";
  const isFunnelPage = pathname === "/";
  const isDocsPage = pathname === "/docs";

  if (isLoginPage || isFunnelPage || isDocsPage) {
    return <main className="min-h-screen">{children}</main>;
  }

  return (
    <>
      <Sidebar />
      <main className="ml-60 min-h-screen">{children}</main>
    </>
  );
}
